module.exports = __webpack_public_path__ + "static/media/Fresh_Rose_TH.6203649a.png";